module.exports = __webpack_public_path__ + "img/aplause.2ab60962.jpg";